import { render, staticRenderFns } from "./modal_comanda_detalhes_teste.vue?vue&type=template&id=60f1284a&scoped=true"
import script from "./modal_comanda_detalhes_teste.vue?vue&type=script&lang=js"
export * from "./modal_comanda_detalhes_teste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1284a",
  null
  
)

export default component.exports